import { useAppSelector, useAppDispatch } from '../state/hooks'
//TODO 20241210 - get these from elsewhere.
/*import {
    addShip,
    ShipFieldsDictionary,
     delShip,
    copyShip,
    Ship, CompDictionary, getCompReference,
} from "../state/slices/diagramSlice"; */
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import { selectCurrentProject, upsertShip, selectCurrentProjectShips, selectCurrentProjectShipIds, selectCurrentProjectComponents } from "../state/slices/systemSlice";
import { localconsole } from "../App";
import DraggableShip from "./DraggableShip";
import { useDrop } from "react-dnd";

//TODO change the component to selection from existing
//TODO change the relationship type to dropdown on table record

interface ShipsProps {
    setActiveShipKey: (activeShipKey:string) => void,
    activeShipKey: string,

    //TODO - next time I do something like this - Could probably make this accordian generic and allow passing in Comp or Ship with a callback to get the expanded layout
}
/*
interface FormProps {
    shipFrom: string, setShipFrom: Dispatch<SetStateAction<string>>,
    shipFromCol: string, setShipFromCol: Dispatch<SetStateAction<string>>,
    shipCardinality: string, setShipCardinality: Dispatch<SetStateAction<string>>,
    shipTo: string, setShipTo: Dispatch<SetStateAction<string>>,
    shipToCol: string, setShipToCol: Dispatch<SetStateAction<string>>,
    shipFreestyle: string, setShipFreestyle: Dispatch<SetStateAction<string>>,
}*/
/*

interface FieldProps {
    label: string,
    placeholder: string,
    value: string,
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,

}
*/

/*

const ItemFormField = (props: FieldProps) => (
    <div className="field" key={props.label}>
        <label className="label">{props.label}</label>
        <div className="control">
            <input className="input"
                   type={"text"}
                   placeholder={props.placeholder}
                   onChange={props.onChange}
                   value={props.value}
            ></input>
        </div>
    </div>
)

const ItemFormFields = (props: FormProps) => (
        <div className={"field"}>
            <ItemFormField label={"From"} placeholder={"Component Name"}
                            onChange={(e) => props.setShipFrom(e.currentTarget.value)}
                            value={props.shipFrom}

            />
            <ItemFormField label={"To"} placeholder={"Component Name"}
                            onChange={(e) => props.setShipTo(e.currentTarget.value)}
                            value={props.shipTo}

            />


            <div className="field" key={"Cardinality"}>
                <label className="label">{"Cardinality"}</label>
                <div className="control">
                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"1:1"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        1:1
                    </label>
                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"1:M"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        1:M
                    </label>
                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"M:1"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        M:1
                    </label>
                </div>
                <div className="control">

                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"ExO"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        Exactly One
                    </label>
                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"ArO"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        Arrow
                    </label>

                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"OoM"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        <span>One or Many</span>
                    </label>
                    <label className="radio">
                        <input type="radio" name="Cardinality"
                               value={"Dot"}
                               onChange={(e) => props.setShipCardinality(e.currentTarget.value)}
                        ></input>
                        Dotted
                    </label>
                </div>
            </div>



            <ItemFormField label={"Source Column"} placeholder={"Column Name"}
                            onChange={(e) => props.setShipFromCol(e.currentTarget.value)}
                            value={props.shipFromCol}

            />
            <ItemFormField label={"Target Column"} placeholder={"Column Name"}
                            onChange={(e) => props.setShipToCol(e.currentTarget.value)}
                            value={props.shipToCol}

            />
            <ItemFormField label={"Other"} placeholder={"Complex Relationship"}
                            onChange={(e) => props.setShipFreestyle(e.currentTarget.value)}
                            value={props.shipFreestyle}

            />
        </div>
    )
*/


function Ships(props: ShipsProps) {
    
    const currentProject = useAppSelector(state => selectCurrentProject(state));
    
    const items = useAppSelector(state => selectCurrentProjectShips(state))
    const existingShipIds = useAppSelector(state => selectCurrentProjectShipIds(state))
    //const existingComponentIds = useAppSelector(state => state.diagram.existingComponentIds)
    const components = useAppSelector(state => selectCurrentProjectComponents(state))
    
    const dispatch = useAppDispatch()
    //use a bit of state to force a re-render when flipping the direction. Doing funky stuff with Optional Select, cant work out how to get it to re-render when state tree updates but also not update when OptionalSelect updates state tree (as I want to type into the box)
    

    /*const [showNewRowForm, setShowNewRowForm] = useState<boolean>(false);
    const [shipFrom, setShipFrom] = useState<string>("");
    const [shipFromCol, setShipFromCol] = useState<string>("");
    const [shipCardinality, setShipCardinality] = useState<string>("1:1");
    const [shipTo, setShipTo] = useState<string>("");
    const [shipToCol, setShipToCol] = useState<string>("");
    const [shipFreestyle, setShipFreestyle] = useState<string>("");*/

    const newItem = () => {
        let new_id = crypto.randomUUID();
        dispatch(upsertShip({
            id: new_id,
            from: "a",
            to: "b",
            cardinality: "Aro",
            tags: [],
        }))
    }

    /*const cancelForm = () => {
        setShowNewRowForm(false);
        setShipFrom("");
        setShipFromCol("");
        //setShipCardinality("1:1");
        setShipTo("");
        setShipToCol("");
        setShipFreestyle("");
    }*/

    /*const saveForm = () => {
        let s: Ship = {
            "id": (existingShipIds.length > 0)?existingShipIds[existingShipIds.length - 1] + 1: 1,
            "from": shipFrom,
            "to": shipTo,
            "cardinality": shipCardinality,
        };
        if ( shipFromCol != "" ) { s["from_col"] = shipFromCol }
        if ( shipToCol != "" ) { s["to_col"] = shipToCol }
        if ( shipFreestyle != "" ) { s["freestyle"] = shipFreestyle }
        dispatch(addShip(s))
        cancelForm()
        setShowNewRowForm(true);
    }*/
    

    /*const itemList = Object.keys(items).map((i) =>
        <tr key={items[i].id} data-key={items[i].id}>
            <td>{items[i].from}</td>
            <td>{items[i].from_col}</td>
            <td>{items[i].cardinality}</td>
            <td>{items[i].to}</td>
            <td>{items[i].to_col}</td>
            <td>{items[i].freestyle}</td>
            <td>
                <button className={"button is-danger is-inverted is-pulled-right"} onClick={binShip}>
                    <span className={"icon"}>
                        <FontAwesomeIcon icon={faTrash} />
                    </span>
                </button>
            </td>
        </tr>
    )*/

    const [, drop] = useDrop(() => ({ accept: 'ship' }))

    const itemAccordian = Object.entries(items).map(([position, ship]) => {
        localconsole(`Rendering Draggable ships position ${position}`)
        return <DraggableShip shipId={ship.id} key={ship.id} isActive={props.activeShipKey == position} shipKey={position} setActive={() => props.setActiveShipKey(position)} setInactive={() => props.setActiveShipKey("")} />
        
        
    })


  return (
    <div className={""}>
        <div className={"block"} ref={drop}>
            {itemAccordian}
        </div>
        <div className={"has-text-centered"}>
            <button className={"button is-success is-inverted pulse is-rounded p-4"} onClick={newItem} onMouseOver={(e) => e.currentTarget.classList.remove("pulse")}
                title={"Add Relationship"}
            >
                <span className={"icon"}>
                    <FontAwesomeIcon icon={faPlus} />
                </span>
            </button>
        </div>

            {/*<div className={"block"}>
                <div className={"buttons is-centered"}>
                    <button className={"button is-success" + ((!showNewRowForm)?"":" is-hidden")} onClick={newItem}>
                        <span className={"icon"}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                        <span>Add</span>
                    </button>
                </div>
            </div>
            <div className={"block" + ((showNewRowForm)?"":" is-hidden")}>
                <ItemFormFields
                    shipFrom={shipFrom} setShipFrom={setShipFrom}
                    shipFromCol={shipFromCol} setShipFromCol={setShipFromCol}
                    shipCardinality={shipCardinality} setShipCardinality={setShipCardinality}
                    shipTo={shipTo} setShipTo={setShipTo}
                    shipToCol={shipToCol} setShipToCol={setShipToCol}
                    shipFreestyle={shipFreestyle} setShipFreestyle={setShipFreestyle}
                />
                <div className={"field is-grouped"}>
                    <div className={"control"}>
                        <button className={"button is-success"} onClick={saveForm}>
                            <span className={"icon"}>
                                <FontAwesomeIcon icon={faFloppyDisk} />
                            </span>
                            <span>Save</span>
                        </button>
                    </div>
                    <div className={"control"}>
                        <button className={"button"} onClick={cancelForm}>Cancel</button>
                    </div>
                </div>
            </div>
            {( existingShipIds.length === 0 )?<div></div>:(
            <div className={"box"}>
                <table className={"table is-fullwidth has-text-centered"}>
                    <thead><tr>
                        <th className={"has-text-centered"}>From</th>
                        <th className={"has-text-centered"}>Source</th>
                        <th className={"has-text-centered"}>Cardinality</th>
                        <th className={"has-text-centered"}>To</th>
                        <th className={"has-text-centered"}>Target</th>
                        <th className={"has-text-centered"}>Other</th>
                    </tr></thead>
                    <tbody>{itemList}</tbody>
                </table>
            </div>
            )}*/}
    </div>
  );
}

export default Ships;